import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import getBusiness from '../../api/queries/getBusiness';
import { setBusiness } from '../../redux/auth/authSlice';
import { useAppDispatch } from '../../redux/hooks';

const useBusiness = () => {
  const { data, isLoading, isStale, isSuccess, error, refetch } = useQuery({
    queryKey: ['getBusiness'],
    queryFn: () => getBusiness(),
  });

  return {
    // Modifiers
    data,
    isLoading,
    isStale,
    isSuccess,
    error: error,
    refetch,
  };
};

const useBusinessSetter = () => {
  const { data, refetch, isLoading, isSuccess } = useBusiness();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (data) {
      dispatch(setBusiness({ business: data }));
    }
  }, [isSuccess, data]);

  return { data, isLoading, refetch };
};

export { useBusinessSetter };
